import { Textarea as BaseTextarea } from 'lp-components'
import { withFormikAdapter } from 'utils'

export default withFormikAdapter()(BaseTextarea)
